import React from "react"
import { useDispatch } from "react-redux"
import { useTranslation } from "react-i18next"
import { IAppState } from "../../../../app/appTypes"
import Button from "../../../../shared/components/buttons/Button"
import { getCurrentUserWithConfig } from "../../../../shared/selectors/user"
import { shareRecommendationAction, deferRecommendationAction } from "../../state/liveMeetingActions"
import { StyleVariants } from "../../../../shared/state/sharedTypes"
import { CaseStage } from "../../state/liveMeetingTypes"
import RecommendationArea from "../shared/RecommendationArea"
import { useSelector } from "react-redux"
import { toggleWebRTCScreenShareIsOnAction } from "../../../webRTC/state/webRTCActions"

interface IPropsFromParent {
  meetingId: string
  buttonsOnly?: boolean
}

const ScribeRecommendation: React.FC<IPropsFromParent> = (props: IPropsFromParent) => {
  const { t } = useTranslation(["shared"])
  const dispatch = useDispatch()
  const currentCaseId = useSelector((state: IAppState) => state.liveMeetingConfig?.selectedMeetingCaseId)
  const currentUserConfig = useSelector((state: IAppState) => getCurrentUserWithConfig(state).config)
  const caseStage = useSelector((state: IAppState) => state.liveMeetingConfig?.caseStage)
  const shareOrRecommend = () => {
    dispatch(toggleWebRTCScreenShareIsOnAction(false))
    dispatch(shareRecommendationAction())
  }
  if (currentCaseId == undefined) return null
  if (caseStage != CaseStage.PRESENTING) return null

  const shareOrDefer = () => {
    if (!currentUserConfig.isPresenter) { return null }
    return (
      <div className="flex flex-wrap flex-1 gap-1 justify-center">
        <Button variant={StyleVariants.PURPLE} action={() => dispatch(deferRecommendationAction())}>
          {t("shared:defer")}
        </Button>
        <Button variant={StyleVariants.BLUE} action={() => shareOrRecommend()}>
          {t("shared:shareAndRecommend")}
        </Button>
      </div>
    )
  }

  return (
    <div className="p-2 rounded-md bg-ch-yellow-200 mt-2 text-ch-gray-600" key={currentCaseId}>
      {props.buttonsOnly ? null : <RecommendationArea meetingId={props.meetingId} readOnly={false} />}
      {shareOrDefer()}
    </div>
  )
}

export default ScribeRecommendation
